import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {isExternalLink, useHistory} from '@aboutyou/router';
import {TrackPromotions} from '@aboutyou/tracking';
import {NotificationCenterCard} from '@aboutyou/ui-components';
import React, {MouseEvent} from 'react';

export const TrackedNotificationCenterCard: React.FC<
  Omit<
    React.ComponentProps<typeof NotificationCenterCard> & {
      tracker: PromotionTracker & {
        notificationType: string;
      };
    },
    'onInfoClick'
  >
> = ({tracker, ...props}) => {
  const history = useHistory();

  const onInfoClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const {info} = props;
    if (info && isExternalLink(info.url)) {
      window.open(info.url, '_blank');
    } else if (info?.url) {
      history.push(info.url);
    }
  };

  return (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.NotificationCenterCards,
        notificationCenterCards: {
          id: tracker.promotionId,
          name: tracker.promotionName,
          path: props.url?.url || '',
          locationId: tracker.locationId || '',
          creative: tracker.creativeName,
          destination: tracker.destination || '',
          originClick: tracker.locationId || '',
        },
      }}
      streamPosition={0}
      data-testid="trackedNotificationCenterCard"
    >
      <NotificationCenterCard {...props} onInfoClick={onInfoClick} />
    </TrackPromotions>
  );
};
